import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  MuiThemeProvider,
  createMuiTheme,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import Select from "react-select";
import { useHistory, useParams } from "react-router-dom";
import {
  deleteLocalidad,
  getLocalidadById,
  postLocalidad,
  updateLocalidad,
} from "../../../../api/localidad";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { checkIsEmpty } from "../../../../utils/helpers";
import { getProvincias } from "../../../../api/provincia";

// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyLocalidad() {
  return {
    fullName: "",
    provincia: "",
  };
}

export default function EditLocalidadesPage() {
  const [localidad, setLocalidad] = useState(getEmptyLocalidad());
  const [provincias, setProvincias] = useState([]);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const localidadId = useParams().id;
  const history = useHistory();

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    getProvincias().then((res) => {
      if (res.status === 200) {
        console.log(res.data);
        setProvincias(res.data);
      }
    });
    if (!localidadId) {
      disableLoadingData();
      return;
    }
    getLocalidadById(localidadId)
      .then((res) => {
        if (res.status === 200) {
          setLocalidad(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se ha podido obtener la localidad.",
        });
        history.push("/localidades");
      });
  }, [localidadId, disableLoadingData, history]);

  function saveLocalidad() {
    if (checkIsEmpty(localidad.fullName))
      return alertError({
        error: null,
        customMessage: "El nombre es requerido.",
      });
    if (!localidadId) {
      postLocalidad(localidad)
        .then((res) => {
          if (res.status === 201) {
            alertSuccess({
              title: "¡Guardado!",
              customMessage: "Localidad creada correctamente.",
            });
            history.push("/localidades");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se ha podido guarda la localidad.",
          });
        });
    } else {
      updateLocalidad(localidadId, localidad)
        .then((res) => {
          if (res.status === 200) {
            alertSuccess({
              title: "¡Guardado!",
              customMessage: "Los cambios se han guardado correctamente.",
            });
            history.push("/localidades");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se han podido guardar los cambios.",
          });
        });
    }
  }

  const handleChange = (element) => (event) => {
    if (element === "provincia") {
      setLocalidad({ ...localidad, [element]: event._id });
    } else setLocalidad({ ...localidad, [element]: event.target.value });
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          <CardHeader title="Editar localidad"></CardHeader>
          <CardBody>
            <TextField
              id={`fullName`}
              label="Nombre"
              value={localidad.fullName}
              onChange={handleChange("fullName")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />
            <span>Provincia</span>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              className="my-2"
              defaultValue={
                localidad.provincia && provincias
                  ? provincias.find((item) => item._id === localidad.provincia)
                  : ""
              }
              onChange={handleChange("provincia")}
              options={provincias}
              getOptionLabel={(option) => `${option.fullName}`}
              getOptionValue={(option) => `${option._id}`}
              placeholder="Seleccione una provincia..."
              styles={{
                // Fixes the overlapping problem of the component
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
            />
          </CardBody>
        </Card>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Button
            onClick={() => history.push("/localidades")}
            variant="outlined"
            style={{ marginRight: "20px" }}
          >
            Atrás
          </Button>
          <Button
            onClick={() => saveLocalidad()}
            variant="outlined"
            color="primary"
            style={{ marginRight: "20px" }}
          >
            Guardar localidad
          </Button>
          {localidadId && (
            <>
              <MuiThemeProvider theme={theme}>
                <Button
                  onClick={() => setOpenConfirmDialog(true)}
                  variant="outlined"
                  color="secondary"
                  style={{ marginRight: "20px" }}
                >
                  Eliminar localidad
                </Button>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginLeft: "auto",
                  }}
                ></div>
              </MuiThemeProvider>

              <ConfirmDialog
                title={"¿Estás seguro de que quieres eliminar esta localidad?"}
                open={openConfirmDialog}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                  deleteLocalidad(localidadId)
                    .then((res) => {
                      if (res.status === 204 || res.status === 200) {
                        alertSuccess({
                          title: "¡Eliminada!",
                          customMessage: "Localidad eliminada correctamente",
                        });
                        history.push("/localidades");
                      }
                    })
                    .catch((error) => {
                      alertError({
                        error: error,
                        customMessage: "No se ha podido eliminar la localidad.",
                      });
                    });
                }}
              />
            </>
          )}
        </div>
      </>
    );
}
